"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var InputGroup_1 = require("./InputGroup");

var Stateful_1 = require("./Stateful");
/**
 * This is a special `<InputGroup>` for `<InputRadio>` components. `<InputRadio>` elements need a parent for state handling. See `<InputRadio>` examples for further information.
 * @visibleName InputGroup.Radio
 */


var Radio =
/** @class */
function (_super) {
  __extends(Radio, _super);

  function Radio() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onChange = function (_value, name, event) {
      _this.props.onChange(name, _this.props.name, event);
    };

    return _this;
  }

  Radio.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        value = _a.value,
        invalid = _a.invalid;
    return React.createElement(InputGroup_1.InputGroup, __assign({}, this.props), React.Children.map(children, function (child, i) {
      var name = child.props.name || i + "";
      return React.cloneElement(child, {
        onChange: _this.onChange,
        name: name,
        value: value === name,
        invalid: invalid && (value === name || !value)
      });
    }));
  };

  Radio.Stateful = Stateful_1.Stateful;
  return Radio;
}(React.Component);

exports.Radio = Radio;